function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { memo } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import messages from 'components/RelatedData/messages';
import StackDataList from '../StackDataList';
import styles from './RelatedData.pcss';
const NoteTooltip = ({ element })=>{
    useStyles(styles);
    const data = [
        {
            value: element.content
        },
        {
            label: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.activity.labels.time)),
            value: moment.unix(element.timestamp).utc().format('LT')
        }
    ];
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.tooltipTitle,
                children: /*#__PURE__*/ _jsx("div", {
                    className: styles.tooltipTitle__titleText,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.note.label))
                })
            }),
            /*#__PURE__*/ _jsx(StackDataList, {
                data: data
            })
        ]
    });
};
export default /*#__PURE__*/ memo(NoteTooltip);
